import {IDictionary} from "modules/types";

export const checksumsSelector = ({checksums}: IDictionary<unknown>) => checksums;
